<template>
  <Row class="full-width-height">
    <Col :span="leftWidth" class="full-height left-container">
      <slot name="left">这是左边</slot>
    </Col>
    <Col :span="rightSpanWidth" class="full-height right-container">
      <slot name="right">这是右边</slot>
    </Col>
  </Row>
</template>

<script>
export default {
  name: 'left-right-container',
  props: {
    leftWidth: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      innerLeftWidth: 6
    }
  },
  computed: {
    rightSpanWidth () {
      return 24 - this.innerLeftWidth
    }
  },
  watch: {
    leftWidth (val) {
      this.innerLeftWidth = val
    }
  }
}
</script>

<style scoped>
  .left-container {
    border-right: #F57C00 1px dashed;
    padding-right: 5px;
  }
  .right-container {
    padding-left: 5px;
  }
  .full-width-height {
    width: 100%;
    height: 100%;
  }
</style>
